import {
  Box, Collapse, IconButton, Paper, Tooltip, Typography,
} from '@mui/material';
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { EventFormStatus, FormMetadata } from '../../core/api/clients';
import { getColor } from '../../core/colors';
import FlightEventList from './FlightEventList';
import useGetFormMetadata from '../../core/api/hooks/common/useGetFormMetadata';
import FlightEventDraftsAndSubmissions from './FlightEventDraftsAndSubmissions';

function FlightEventLanding({ formMetadata }:{ formMetadata: FormMetadata }) {
  if (!formMetadata) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const { data: authorizedForm } = useGetFormMetadata(formMetadata.componentName ?? '');

  if (!authorizedForm?.metadata) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  return (
    <React.Fragment>
      <Collapse in={authorizedForm?.isContributor}>
        <FlightEventDraftsAndSubmissions pageSize={10} formMetadata={formMetadata} />
      </Collapse>
      <Collapse in={authorizedForm?.isAdministrator || authorizedForm?.isApprover || authorizedForm?.isReader}>
        <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
          <Box display="flex" alignItems="center" flexGrow={1}>
            <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
              Flight Event Forms (Last 7 Days)
              <Tooltip title="This section shows the forms from the last 7 days using the date the report was created.">
                <IconButton>
                  <InfoOutlined />
                </IconButton>
              </Tooltip>
            </Typography>
          </Box>
        </Box>
        <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
          <FlightEventList
            statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
            pageSize={10}
            hours={168}
          />
        </Paper>
      </Collapse>
    </React.Fragment>
  );
}

export default FlightEventLanding;
